<template>
          <v-dialog v-model="showConfirm" persistent max-width="360">
          <v-card>
            <v-card-title style="color: #065535; font-weight: 400; font-size: 1.1em;">{{title}}</v-card-title>
            <v-card-text v-html="message"/>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#065535" text @click="doConfirm" style="font-weight: 400;">{{titleOk}}</v-btn>
              <v-btn v-if="!!titleCancel" text @click="doCancel" style="font-weight: 400;">{{titleCancel}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
</template>

<script>
 
  export default {
    name: 'ConfirmDialog', 
    props: ['message','titleOk','titleCancel','title'],
    data(){
        return { 
             payload:null,
             showConfirm: false
        }

    },  
    methods: {
				confirm(payload)
        { 
            this.payload=payload;
            this.showConfirm=true;
        }
        ,
        doConfirm()
        {
            this.showConfirm = false;
            this.$emit('confirmed',this.payload);
        },
        doCancel()
        {
            this.showConfirm = false;
            this.$emit('canceled',this.payload);
        }
      },
  }
</script>